<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="activatingPopUp = false"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Menu</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="menuList"
          class="w-full"
          :disabled="menuList.length === 0"
          :reduce="(e) => e.id"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="menu"
          label="name"
          v-model="formData.menu_id"
          placeholder="Pilih Menu Teregistrasi"
        />
        <span class="text-danger text-sm">{{ errors.first("menu") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Level</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="levelList"
          class="w-full"
          :reduce="(e) => e.id"
          :disabled="levelList.length === 0"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="level"
          label="name"
          v-model="formData.level_id"
          placeholder="Pilih Level"
        />
        <span class="text-danger text-sm">{{ errors.first("level") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Aksesbilitas</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <div class="flex justify-between items-center mb-4">
          <h5>Create</h5>
          <vs-switch v-model="createBool" />
        </div>
        <div class="flex justify-between items-center mb-4">
          <h5>Update</h5>
          <vs-switch v-model="updateBool" />
        </div>
        <div class="flex justify-between items-center mb-4">
          <h5>Delete</h5>
          <vs-switch v-model="deleteBool" />
        </div>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button color="success" class="ml-2 rounded-2xl" @click="addData">{{
          labelButton
        }}</vs-button>
      </div>
    </footer>
  </vs-popup>
</template>
<script>
export default {
  props: {
    menuList: [],
    levelList: [],
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      formData: {
        level_id: null,
        menu_id: null,
        create: 1,
        update: 1,
        delete: 1,
      },
      createBool: true,
      updateBool: true,
      deleteBool: true,
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Role" : "Tambah Role";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.level_id !== null &&
        this.formData.menu_id !== null &&
        this.formData.create !== null &&
        this.formData.update !== null &&
        this.formData.delete !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.level_id = this.passData.level.id;
        this.formData.menu_id = this.passData.menu.id;
        this.formData.create = this.passData.create;
        this.formData.update = this.passData.update;
        this.formData.delete = this.passData.delete;
        this.createBool = this.passData.create === 1;
        this.updateBool = this.passData.update === 1;
        this.deleteBool = this.passData.delete === 1;
      } else {
        this.resetData();
      }
    },
  },
  methods: {
    resetData() {
      this.formData.level_id = null;
      this.formData.menu_id = null;
      this.formData.create = 1;
      this.formData.update = 1;
      this.formData.delete = 1;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      console.log(this.updateBool);
      this.formData.create = this.createBool === true ? 1 : 2;
      this.formData.update = this.updateBool === true ? 1 : 2;
      this.formData.delete = this.deleteBool === true ? 1 : 2;
      this.$store
        .dispatch("role/cudRole", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title: this.passData !== null ? "Edit Role Sukses!" : "Tambah Role Sukses!",
            text:
              this.passData !== null ? `Role Berhasil diedit` : `Role Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetData();
        });
    },
  },
};
</script>
